import request, { privateRequest } from "lib/request";

const API_URL = "/api/categories";

export const fetchCategoriesAPI = async () => {
  try {
    const response = await request.get(API_URL);
    return response.data;
  } catch (error) {
    console.error("Error fetching categories:", error);
    throw error;
  }
};

export const fetchCategoryByIdAPI = async (id) => {
  try {
    const response = await request.get(`${API_URL}/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching category:", error);
    throw error;
  }
};

export const createCategoriesAPI = async (data) => {
  try {
    const response = await privateRequest.post(API_URL, data, {
      "Content-Type": "multipart/form-data",
    });
    return response.data;
  } catch (error) {
    console.error("Error creating category:", error);
    throw error;
  }
};

export const deleteCategoriesAPI = async (id) => {
  try {
    const response = await privateRequest.delete(`${API_URL}/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching categories:", error);
    throw error;
  }
};

export const updateCategoryAPI = async (id, data) => {
  try {
    const response = await privateRequest.put(`${API_URL}/${id}`, data, {
      "Content-Type": "multipart/form-data",
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching categories:", error);
    throw error;
  }
};
